<template>
<div class="uploadFile">
    <el-upload :auto-upload="false" class="upload-demo" ref="upload"
        :action="uploadSetting.uploadurl"
        :accept="fileRule.accept"
        :on-change="handleAvatarChange"
        :file-list="fileList">
        <el-button slot="trigger" size="small" type="primary" :disabled="checkDisabled">{{fileRule.btnName}}</el-button>
        <!--<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
    </el-upload>
    <el-dialog title="上传进度" :visible.sync="isUpload">
        <div class="progress">
            <div>{{file.name}}</div>
            <el-progress :percentage="percentage"></el-progress>
            <div class="tc-blue">{{fsize(file.size* percentage / 100)}}/{{fsize(file.size)}}</div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import {getUploadParam, qiniuFormUpload} from 'api/api'
import {numberRound, computeFileSize} from 'common/js/tools'
import {mapActions} from 'vuex'
export default {
    name: 'uploadFile',
    data() {
        return {
            isUpload: false,
            fileList: [],
            uploadSetting: {
                localvurl: '', // 本地访问图片地址
                uploadauth: '', // 授权信息
                uploadfilekey: '', // 文件保存名字
                uploadurl: '' // 上传文件地址
            },
            percentage: 0,
            file: {
                size: 0,
                name: ''
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 1, // 1自己上传 2素材 3系统默认资源
                furl: ''
            }
        }
    },
    props: ['fileRule', 'uploadType', 'checkDisabled'],
    mounted() {
    },
    methods: {
        initUploadParam() {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        handleAvatarChange(file, fileList) {
            if (this.uploadSetting.uploadauth) {
                this.uploadFile(file)
            } else {
                this._getUploadParam(file)
            }
        },
        // 获取上传参数
        _getUploadParam(file) {
            //20211027 获取文件后缀名
            let orginalfilename=file.name
            if(orginalfilename==''){
                this.$message.error("请选择正确的文件!");
                return
            }
            //给上传文件增加后缀名
            let fileSuffix=''
            let fileSuffixPos = orginalfilename.lastIndexOf(".");
            if(fileSuffixPos>=0){
                fileSuffix = orginalfilename.substring(fileSuffixPos,orginalfilename.length)
            }
            this.uploadType.filesuffix=fileSuffix

            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadFile(file)
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        // 上传
        uploadFile(file) {
            if (file.size/1024/1024 > 10) {
                this.$message.error('视频大小不要超过10M！')
                return
            }
            this.isUpload = true
            this.file = file
            this.percentage = 0
            const axiosInstance = axios.create({withCredentials: false}) // withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
            let formData = new FormData()
            formData.append('file', file.raw)
            formData.append('key', this.uploadSetting.uploadfilekey)
            formData.append('token', this.uploadSetting.uploadauth)
            this.setLoading(true)
            axiosInstance({
                method: 'POST',
                url: this.uploadSetting.uploadurl, // 上传地址
                data: formData,
                timeout: 30000, // 超时时间，因为图片上传有可能需要很久
                onUploadProgress: (progressEvent) => { // imgLoadPercent 是上传进度，可以用来添加进度条
                    this.percentage = Math.round(progressEvent.loaded * 100 / progressEvent.total)
                    if (this.percentage === 100) {
                        setTimeout(() => {
                            this.isUpload = false
                        }, 1000)
                    }
                }
            }).then(data => {
                data = JSON.parse(data.request.response)
                data.fsize = numberRound(data.fsize, 0)
                this.$emit('setFile', Object.assign({}, data, this.fileOtherInfo))
                this.setLoading(false)
                // document.getElementById('uploadFileInput').value = '' // 上传成功，把input的value设置为空，不然 无法两次选择同一张图片
                // 上传成功...  (登录七牛账号，找到七牛给你的 URL地址) 和 data里面的key 拼接成图片下载地址
            }).catch(data => {
                this.$message.error('上传失败，请重新上传')
                this.setLoading(false)
            })

            // let flag = this.beforeAvatarUpload(file.raw)
            // if (flag) {
            //     let formData = new FormData()
            //     formData.append('file', file.raw)
            //     formData.append('key', this.uploadSetting.uploadfilekey)
            //     formData.append('token', this.uploadSetting.uploadauth)
            //     this.setLoading(true)
            //     qiniuFormUpload({
            //         url: this.uploadSetting.uploadurl,
            //         data: formData,
            //         success: (data) => {
            //             data.fsize = numberRound(data.fsize / 1024, 0)
            //             this.$emit('setFile', Object.assign({}, data, {furl: this.uploadSetting.localvurl}))
            //             this.setLoading(false)
            //         },
            //         error: (data) => {
            //             this.$message.error('上传失败，请重新上传')
            //             this.setLoading(false)
            //         }
            //     })
            // }
        },
        beforeAvatarUpload(file) {
            // 验证格式
            let acceptType = this.fileRule.accept.split(',')
            let isFile = false
            if (!acceptType.length) {
                isFile = true
            } else {
                acceptType.forEach(item => {
                    if (file.type === item) {
                        isFile = true
                        return false
                    }
                })
            }
            if (!isFile) {
                this.$message.error('上传文件格式错误!')
            }
            const isLt2M = file.size / 1024 / 1024 < this.fileRule.size
            // 验证大小
            if (!isLt2M) {
                this.$message.error(`上传文件大小不能超过 ${this.fileRule.size}MB!`)
            }
            return isFile && isLt2M
        },
        submitUpload() {
            this.$refs.upload.submit()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        fsize () {
            return function(size) {
                return computeFileSize(size)
            }
        }
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.uploadFile {
    @include flexBox(space-between);
    .el-upload-list{
        display: none;
    }
    .progress{
        padding: 20px;
        background: $line;
        .el-progress__text{
            color: $tcolor-blue;
        }
    }
}
</style>
